import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';

export const mobileAppLinks: Partial<Record<Portal, { appleStore: string; googlePlay: string }>> = {
    [Portal.ImmoWelt]: {
        appleStore: 'https://app.adjust.com/1k58m8ai_1krjzhhi',
        googlePlay: 'https://app.adjust.com/1k5lkhi3_1k5pfaot',
    },
    [Portal.Immonet]: {
        appleStore: 'https://app.adjust.com/1k3nqpuo_1kajdk44',
        googlePlay: 'https://app.adjust.com/1k3on0wz_1k5lb12h',
    },
    [Portal.SeLoger]: {
        appleStore: 'https://app.adjust.com/1k93jvle_1kg9722r',
        googlePlay: 'https://app.adjust.com/1kb4ka5e_1kp53ypp',
    },
};
